import React from "react";
import {
  Box,
  Drawer,
  IconButton,
  Typography,
  Divider,
  Avatar,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// Assuming you have Iconify or use MUI icons
import Iconify from "../iconify/Iconify";

function OrderActivityDrawer({
  openOrderActivityDrawer,
  setOpenOrderActivityDrawer,
}) {
  // Hardcoded rich activity data
  const orderActivities = [
    {
      id: 1,
      type: "CREATED",
      title: "Order Created",
      description: "Table G2 • Started by Owner Rajendra",
      time: "12:30 PM",
      icon: "solar:shop-2-bold",
      color: "#1976d2", // Primary Blue
    },
    {
      id: 2,
      type: "CUSTOMER",
      title: "Customer Linked",
      description: "Guest: Rahul Sharma (+91 98765...) added",
      time: "12:31 PM",
      icon: "solar:user-plus-bold",
      color: "#9c27b0", // Purple (New category)
    },
    {
      id: 3,
      type: "ADDED",
      title: "Items Added",
      description: "+2 Special Chai (Cutting), +1 Nariyal Pani",
      time: "12:32 PM",
      icon: "solar:add-circle-bold",
      color: "#2e7d32", // Green
    },
    {
      id: 4,
      type: "HOLD",
      title: "Order on Hold",
      description: "Entire order placed on hold by Rajendra",
      reason: "Waiting for guest arrival",
      time: "12:35 PM",
      icon: "solar:pause-circle-bold",
      color: "#ed6c02", // Orange (Warning/Wait)
    },
    {
      id: 5,
      type: "KOT",
      title: "KOT Generated",
      description: "KOT #1 (3 items) printed to Kitchen",
      time: "12:45 PM",
      icon: "solar:printer-minimalistic-bold",
      color: "#757575", // Gray (System action)
    },
    {
      id: 6,
      type: "DELETED",
      title: "Item Voided",
      description: "-1 Nariyal Pani removed from KOT #1",
      reason: "Item unavailable in stock",
      time: "12:50 PM",
      icon: "solar:trash-bin-trash-bold",
      color: "#d32f2f", // Red
    },
    {
      id: 7,
      type: "SETTLE",
      title: "Payment Initiated",
      description: "Bill generated • Total: ₹2,408.00",
      time: "01:15 PM",
      icon: "solar:card-2-bold",
      color: "#2e7d32", // Green (Success/Money)
    },
    {
      id: 8,
      type: "CANCEL",
      title: "Order Canceled",
      description: "Order voided by Manager",
      reason: "Customer left without eating",
      time: "01:20 PM",
      icon: "solar:close-circle-bold",
      color: "#b71c1c", // Dark Red (Critical)
    },
  ];

  return (
    <Drawer
      anchor="right"
      open={openOrderActivityDrawer}
      onClose={() => setOpenOrderActivityDrawer(false)}
      PaperProps={{
        sx: { width: { xs: "100%", sm: 400 } },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          p: 1.2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          bgcolor: "white",
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Typography
            fontWeight={700}
            style={{
              fontSize: "1.1rem",
            }}
          >
            Order Activity
          </Typography>
          <Typography variant="caption" sx={{ fontWeight: 500, pl: 1 }}>
            (ORD-102)
          </Typography>
        </Box>
        <IconButton onClick={() => setOpenOrderActivityDrawer(false)}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />

      {/* Timeline List */}
      <Box sx={{ p: 3, flexGrow: 1, overflowY: "auto" }}>
        {orderActivities.map((activity, index) => (
          <Box
            key={activity.id}
            sx={{
              display: "flex",
              gap: 2,
              position: "relative",
              pb: index === orderActivities.length - 1 ? 0 : 4,
            }}
          >
            {/* The Vertical Connector Line */}
            {index !== orderActivities.length - 1 && (
              <Box
                sx={{
                  position: "absolute",
                  left: 16,
                  top: 36,
                  bottom: 0,
                  width: "2px",
                  borderLeft: "2px dashed #e0e0e0",
                }}
              />
            )}

            {/* Icon Node */}
            <Avatar
              sx={{
                width: 34,
                height: 34,
                bgcolor: `${activity.color}15`, // Light version of color
                color: activity.color,
                border: `1px solid ${activity.color}`,
                zIndex: 1,
              }}
            >
              <Iconify icon={activity.icon} width={20} />
            </Avatar>

            {/* Content Card */}
            <Box sx={{ flex: 1 }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 700, color: "#212b36" }}
                >
                  {activity.title}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{ color: "text.secondary", fontWeight: 500 }}
                >
                  {activity.time}
                </Typography>
              </Stack>

              <Typography
                variant="body2"
                sx={{ color: "text.secondary", mt: 0.5, fontSize: "0.825rem" }}
              >
                {activity.description}
              </Typography>

              {activity.reason && (
                <Box
                  sx={{
                    mt: 1,
                    p: 1,
                    bgcolor: "#fff1f0",
                    borderRadius: 1,
                    borderLeft: "3px solid #d32f2f",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#d32f2f",
                      fontStyle: "italic",
                      display: "block",
                    }}
                  >
                    Reason: {activity.reason}
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Drawer>
  );
}

export default OrderActivityDrawer;
